import { render, staticRenderFns } from "./WaveViewer.vue?vue&type=template&id=0c61d1c6&"
import script from "./WaveViewer.vue?vue&type=script&lang=js&"
export * from "./WaveViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WaveViewer.vue"
export default component.exports